import { render, staticRenderFns } from "./AddDeclarationDocumentDialog.vue?vue&type=template&id=46102884&scoped=true"
import script from "./AddDeclarationDocumentDialog.vue?vue&type=script&lang=ts"
export * from "./AddDeclarationDocumentDialog.vue?vue&type=script&lang=ts"
import style0 from "./AddDeclarationDocumentDialog.vue?vue&type=style&index=0&id=46102884&prod&scoped=true&lang=scss"
import style1 from "./AddDeclarationDocumentDialog.vue?vue&type=style&index=1&id=46102884&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46102884",
  null
  
)

export default component.exports